import { api } from '@/fsd/shared/api';

interface IParams {
  id: number;
  status: 'close' | 'open' | 'progress';
  comment?: string;
}

interface IResponse {
  id?: number;
  year: number;
  month: number;
  status?: 'close' | 'open' | 'progress';
}

export const updateClosureMonth = async ({
  id,
  status,
  comment,
}: IParams): Promise<IResponse | undefined> => {
  try {
    const data = await api.put<IResponse>(
      `/api/v1/monthly_closure/close/month/${id}/`,
      {
        body: { status, comment },
      }
    );

    return data;
  } catch (e) {
    console.error('Ошибка при обновлении месяца закрытия:', e);
    return;
  }
};
